import * as Constants from '../constants/action-constants';
import { PageAction } from '../types/Common';
import { MapMarker } from '../types/Dashboard';

export interface RequestActions {
  type: Constants.REQUEST_ACTIONS;
}

export interface RequestActionsSuccess {
  type: Constants.REQUEST_ACTIONS_SUCCESS;
  payload: {
    actions: PageAction[];
  };
}

export interface RequestDashboardData {
  type: Constants.REQUEST_DASHBOARD_DATA;
}

export interface RequestMapData {
  type: Constants.REQUEST_MAP_DATA;
}

export interface RequestMapDataSuccess {
  type: Constants.REQUEST_MAP_DATA_SUCCESS;
  payload: {
    markers: MapMarker[];
  };
}

export interface RequestMapDataFailed {
  type: Constants.REQUEST_MAP_DATA_FAILED;
}

export type DashboardAction =
  | RequestActions
  | RequestActionsSuccess
  | RequestDashboardData
  | RequestMapData
  | RequestMapDataSuccess
  | RequestMapDataFailed;

export const requestActions = (): RequestActions => ({
  type: Constants.REQUEST_ACTIONS
});

export const requestActionsSuccess = (
  actions: PageAction[]
): RequestActionsSuccess => ({
  payload: { actions },
  type: Constants.REQUEST_ACTIONS_SUCCESS
});

export const requestDashboardData = (): RequestDashboardData => ({
  type: Constants.REQUEST_DASHBOARD_DATA
});

export const requestMapData = (): RequestMapData => ({
  type: Constants.REQUEST_MAP_DATA
});

export const requestMapDataSuccess = (
  markers: MapMarker[]
): RequestMapDataSuccess => ({
  payload: { markers },
  type: Constants.REQUEST_MAP_DATA_SUCCESS
});

export const requestMapDataFailed = (): RequestMapDataFailed => ({
  type: Constants.REQUEST_MAP_DATA_FAILED
});
